import { Outlet } from "react-router-dom";

const Cabletv = () => {
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  );
};

export default Cabletv;
